import { creatMapAndListSync } from 'presentation/libs/MapAndListSync/MapAndListSync'

export const SearchHistoryMapAndListSync = creatMapAndListSync()
